import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import AgendaItemAttendee from "@/domain/entities/agenda/AgendaItemAttendee";
import AgendaItemOrganizer from "@/domain/entities/agenda/AgendaItemOrganizer";
import { Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import EventAttendee from "./EventAttendee";

type EventAttendeeListProps = {
    attendees: AgendaItemAttendee[];
    organizer?: AgendaItemOrganizer;
};

const EventAttendeeList = ({
    attendees,
    organizer,
}: EventAttendeeListProps) => {
    const { t } = useTranslation();

    return (
        <Accordion type="single" collapsible>
            <AccordionItem value="attendees" variant="invisible">
                <AccordionTrigger>
                    <div className="flex items-center gap-4">
                        <Users className="h-4 w-4" />
                        <p>
                            {t(
                                "dashboard.widgets.calendar.event.attendeesCount",
                                {
                                    count: attendees?.length,
                                },
                            )}
                        </p>
                    </div>
                </AccordionTrigger>
                <AccordionContent
                    className="max-h-[400px] overflow-auto"
                    style={{
                        scrollbarColor: "#d7d9ff #f1f5f900",
                    }}
                >
                    <div className="flex flex-col gap-1">
                        {attendees?.map((attendee) => (
                            <EventAttendee
                                key={attendee.emailAddress.address}
                                attendee={attendee}
                                organizer={organizer}
                            />
                        ))}
                    </div>
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
};

export default EventAttendeeList;
